import { render, staticRenderFns } from "./AbsModule.vue?vue&type=template&id=224fdd7a&scoped=true&"
import script from "./AbsModule.vue?vue&type=script&lang=js&"
export * from "./AbsModule.vue?vue&type=script&lang=js&"
import style0 from "./AbsModule.vue?vue&type=style&index=0&id=224fdd7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224fdd7a",
  null
  
)

export default component.exports